import { FormattedMessage } from "react-intl";
import { AEOverlayTrigger } from "../../AEOverlayTrigger";
import { AESVG } from "../svg";
import { Tooltip } from "react-bootstrap";
import React from "react";
const BasicBadge = ({ svg, variant, size, tooltipMessage }) => {
  return (
    <AEOverlayTrigger
      placement={"top"}
      overlay={
        <Tooltip id={`tooltip_user_activation_badge`}>
          <FormattedMessage id={tooltipMessage} />
        </Tooltip>
      }
    >
      <AESVG path={svg} variant={variant} size={size} />
    </AEOverlayTrigger>
  );
};
export default BasicBadge;
